import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
    palette: {
        primary: {
            main: '#2289ff',
            contrastText: '#ffffff'
        },
        secondary: { main: '#11cb5f' },
        contrastThreshold: 3,
        tonalOffset: 0.2
    },
    typography: {
        
    }
});

export default theme;



// WEBPACK FOOTER //
// ./src/Theme.js